import React from 'react';
import logo from '../assets/Images/wglogo.png'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PrimaryButton from '../Co Components/PrimaryButton';
import { useState } from "react";
const Nav = () => {
    const location = useLocation();
    const pathname = location.pathname;
    // const linkName = toString(link);
    // console.log(linkName);
    const [state, setState] = useState(false);
    const navigate = useNavigate();
    return (
        <nav className='navbar nav-container fixed-top justify-content-between navbar-expand-lg navbar-expand-lg'>
            <div className="container-fluid justify-content-between nav-container">
                <button className="navbar-toggler menu-focus" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setState(!state)}>
                    <span className={state ? 'd-none' : 'navbar-toggler-icon'}></span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className={state ? 'bi bi-x-lg' : 'd-none'} viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                    </svg>
                </button>
                <Link to="/" className="navbar-brand logo-img logo-size mx-4" >
                    <img src={logo} width="30" height="30" className="d-inline-block align-top" alt="White Gaurd logo"></img>
                </Link>


                <div className="collapse navbar-collapse nav-menu" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className={pathname === '/' ? 'active nav-link' : 'nav-link'} aria-current="page" to="/">Why WHITEGUARD?</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={pathname === '/services' ? 'active nav-link' : 'nav-link'} to="/services">Services</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={pathname === '/white-hawk' ? 'active nav-link' : 'nav-link'} to="/white-hawk">White Hawk</Link>
                        </li>
                         <li className="nav-item dropdown">
                            <Link className={pathname === '/tech-partners' || pathname==='/resellers-partners' ? 'active dropbtn nav-link' : ' dropbtn nav-link'} >Partners</Link>
                             <div style={{transition:'all 0.3s ease'}} className=" dropdown-content shadow">
                                 <Link className={'text-decoration-none'} to={"/resellers-partners"}>Resellers</Link>
                                 <Link className={'text-decoration-none'} to={"/tech-partners"}>Technology</Link>
                             </div>
                        </li>
                        <li className="nav-item">
                            <Link className={pathname === '/blog' ? 'active nav-link' : 'nav-link'} to="/blog">Blogs</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={pathname === '/about' ? 'active nav-link' : 'nav-link'} to="/about">About Us</Link>
                        </li>
                        <li className="nav-item d-lg-none">
                            <Link className={pathname === '/contact' ? 'active nav-link' : 'nav-link'} to="/contact">Contact Us</Link>
                        </li>

                    </ul>

                </div>
                <Link to={'/contact'} className='contact-btn'><PrimaryButton text="contact us" /></Link>

            </div>
        </nav>
    );

}

export default Nav;